import { ShieldCheck, Lock, Heart } from "lucide-react";
import FadeUp from "../components/site/FadeUp";
import CTASection from "../components/site/CTASection";
import founderPhoto from "../assets/founder.jpg";

const PROMISES = [
  {
    icon: ShieldCheck,
    title: "Insured & bonded",
    body: "Every team member is fully insured and bonded before they ever enter your home.",
  },
  {
    icon: Lock,
    title: "Confidentiality promise",
    body: "We sign a confidentiality agreement with every client. What happens in your home stays private.",
  },
  {
    icon: Heart,
    title: "Never sold, ever",
    body: "Your information is never sold or shared. Trust is the whole point of what we do.",
  },
];

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="section-pad">
        <div className="container-hh grid items-center gap-12 lg:grid-cols-2">
          <FadeUp>
            <p className="eyebrow">Meet our founder</p>
            <h1 className="mt-3 text-4xl md:text-5xl lg:text-6xl">
              Hi, I'm Sarah.
            </h1>
            <div className="mt-6 space-y-4 text-lg leading-relaxed text-bodytext">
              <p>
                After years as a college soccer coach, I found myself juggling
                work, motherhood, and the endless mental load that so many women
                quietly carry. I realized there was a gap — not for another
                cleaning company, but for someone to truly help families breathe
                again.
              </p>
              <p>
                That's why I created Harbor Home: to give busy families more
                time, less stress, and the freedom to be fully present for the
                moments that matter most.
              </p>
              <p>
                Today, Harbor Home is a growing team of people I'd trust in my
                own home, serving families across the South Shore. We're locally
                owned, fully insured and bonded, and bound by a confidentiality
                promise. Your information is never sold.
              </p>
            </div>
          </FadeUp>
          <FadeUp delay={0.1}>
            <div className="overflow-hidden rounded-[12px] shadow-cozy-lg">
              <img
                src={founderPhoto}
                alt="Sarah, founder of Harbor Home Concierge, with her daughter by the beach"
                className="h-full max-h-[620px] w-full object-cover"
              />
            </div>
          </FadeUp>
        </div>
      </section>

      <section className="section-pad bg-seafoam">
        <div className="container-hh">
          <FadeUp className="max-w-2xl">
            <p className="eyebrow">Our promise</p>
            <h2 className="mt-3 text-3xl md:text-4xl lg:text-5xl">
              Trust, in writing
            </h2>
          </FadeUp>
          <div className="mt-12 grid gap-8 md:grid-cols-3">
            {PROMISES.map((p, i) => (
              <FadeUp key={p.title} delay={i * 0.1}>
                <div className="cozy-card h-full p-8">
                  <div className="flex h-12 w-12 items-center justify-center rounded-full bg-seafoam">
                    <p.icon className="h-6 w-6 text-teal" />
                  </div>
                  <h3 className="mt-5 text-2xl">{p.title}</h3>
                  <p className="mt-3 leading-relaxed text-bodytext">{p.body}</p>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>
      </section>

      <CTASection />
    </div>
  );
}
